var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKnowledgeSegment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "500px",
    height: "500px",
    viewBox: "0 0 500 500",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Knowledge Segment") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 250,
    cy: 250,
    r: 250,
    fillOpacity: 0,
    pointerEvents: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M250.234071,250.032052 L250.179225,250.048421 L250.193847,250.058375 L103.100824,452.195201 C187.503123,513.639437 304.825094,517.502369 394.406406,454.17435 L397.112437,452.234742 L250.234071,250.032052 Z",
    id: "knowledge-segment",
    fill: "#EB5C37",
    pointerEvents: "visiblePainted"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKnowledgeSegment);
export default __webpack_public_path__ + "static/media/Knowledge-Segment.7614eecbac9b78c60b9b3fdf164da89d.svg";
export { ForwardRef as ReactComponent };